import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { TtqCttqWorkbenchContent } from '../../components/ttq/TtqCttqPanel';
import { TtqWorkbenchShell } from '../../features/ttqib/ttqWorkbenchShared';
import { parseTtqWorkbenchParticles } from '../../features/ttqib/ttqWorkbenchRoutes';
import { ttqService, type TtqSession } from '../../services/ttqService';

export function TtqCttqWorkbenchPage() {
  const { ttqaId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const particleIds = useMemo(() => parseTtqWorkbenchParticles(searchParams), [searchParams]);
  const [session, setSession] = useState<TtqSession | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    void ttqService.getSession(ttqaId)
      .then((s) => active && setSession(s))
      .catch((e) => active && setError(e instanceof Error ? e.message : '加载失败'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [ttqaId]);

  return (
    <TtqWorkbenchShell
      ttqaId={ttqaId}
      title="收敛品题（CTTQ）"
      angleId="cttq_converge"
      loading={loading}
      error={error}
      restoreParticleIds={particleIds}
    >
      {session ? (
        <TtqCttqWorkbenchContent
          session={session}
          onSessionUpdated={setSession}
          onOpenParticle={(particleId) => navigate(`/knowledge/${particleId}`)}
          initialMemberIds={particleIds}
          initialCttqParticleId={particleIds[0] ?? null}
        />
      ) : (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin text-primary" /></div>
      )}
    </TtqWorkbenchShell>
  );
}
